module.exports = __webpack_public_path__ + "img/recdis.60aa7136.svg";